import {
  DEV_SITE_HOSTS,
  URL_CANDIDATES,
  URL_CANDIDATES_ACTIONS,
  URL_YOUR_CANDIDATES,
} from '@seek/adv-constants';
import {
  getLocalizedRoutes,
  siteNames,
  type SiteNamesMatchingClassification,
} from '@seek/melways-sites';
import type { SkuConfig } from 'sku';

type SkuSite = Extract<SkuConfig['sites'], object>[number];
type SkuSiteObject = Extract<SkuSite, object>;

export type EmployerSiteNames = SiteNamesMatchingClassification<{
  product: 'employer';
}>;

export const publicPath = '/static/cm-ui-unified';

export type Environment = 'dev' | 'production' | 'staging';

export const environments = {
  development: 'dev',
  production: 'production',
  staging: 'staging',
};

export const routes = [
  { route: URL_CANDIDATES, name: 'candidates' },
  { route: '/candidates/error/404', name: 'error' },
  { route: URL_CANDIDATES_ACTIONS, name: 'actions' },
  { route: URL_YOUR_CANDIDATES, name: 'your-candidates' },
] satisfies SkuSiteObject['routes'];

const localiseRoutesForSite = getLocalizedRoutes(routes);

const createSites = (sites: EmployerSiteNames[]): SkuSiteObject[] =>
  sites.map((site) => ({
    name: site,
    host: DEV_SITE_HOSTS[site],
    routes: localiseRoutesForSite(site),
  }));

export const sites = createSites([
  siteNames.employer.seek.au,
  siteNames.employer.seek.nz,
  siteNames.employer.seek.hk,
  siteNames.employer.seek.th,
  siteNames.employer.seek.sg,
  siteNames.employer.seek.id,
  siteNames.employer.seek.ph,
  siteNames.employer.seek.my,
]);
